import { ActionReducerMap } from '@ngrx/store';

export const reducers: ActionReducerMap<any> = {
  // test: (state, action) => {
  //   Log.log(state, action);
  //   return state;
  // }
};
